import {takeLatest, put, call} from 'redux-saga/effects'
import {
  FEEDBACK_FORM_PAGE_REQUEST,
  FEEDBACK_FORM_SUBMIT_FEEDBACK
} from 'actions/feedbackForm/constants'
import {initialize, reset} from 'redux-form'
import {
  isInvalidFeedback,
  isSubmitSuccess,
  setDataCheckFeedbackToken,
  showForm
} from 'actions/feedbackForm'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import {checkFeedbackToken} from 'api/feedbackReplyForm'
import {postCustomerFeedback} from 'api/customers'

function * fillCustomerFeedbackForm () {
  let form = {
    feedbackType: 'wait_time',
    comment: ''
  }
  yield put(initialize('customerFeedbackForm', form))
}

export function * pageRequest (request) {
  try {
    yield put(act.showProgressBar())
    const {payload: {params}} = request
    let resFeedbackToken = yield call(checkFeedbackToken, params.feedback_token)
    let invalidToken = resFeedbackToken.data.feedback_error
    let data = resFeedbackToken.data
    if (invalidToken) {
      yield put(isInvalidFeedback(true))
    } else {
      yield put(showForm(true))
    }
    yield call(fillCustomerFeedbackForm)
    yield put(setDataCheckFeedbackToken(data))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * submitCustomerFeedback (request) {
  try {
    yield put(act.showProgressBar())
    let {payload: {data}} = request
    let res = yield call(postCustomerFeedback, data)
    let {error} = res.data
    if (!error) {
      yield put(showForm(false))
      yield put(isSubmitSuccess(true))
    } else {
      yield put(isInvalidFeedback(true))
      yield put(showForm(false))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(reset('customerFeedbackForm'))
    yield put(act.hideProgressBar())
  }
}

export default function * feedbackFormSaga () {
  yield takeLatest(FEEDBACK_FORM_PAGE_REQUEST, pageRequest)
  yield takeLatest(FEEDBACK_FORM_SUBMIT_FEEDBACK, submitCustomerFeedback)
}



// WEBPACK FOOTER //
// ./app/sagas/feedbackForm/index.js